module.exports = __webpack_public_path__ + "static/media/image4.0b4d9f00.png";